<template>
  <div class="flex flex-col">
    <TableDocs type="Devis" api-type="quotes" number-prefix="DV" />
  </div>
</template>

<script>
import TableDocs from '@/components/Table/Docs'

export default {
  components: {
    TableDocs,
  },
  theme() {
    return {
      title: 'Devis',
      buttons: [
        {
          to: '/quotes/add',
          label: '+ Ajouter devis',
        },
      ],
    }
  },
}
</script>

<style></style>
